import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { useReportDeailStore } from 'store';

// needs to be updated based on environment and api endpoint
const apiURL = ENV_VARS.API_URL;

export const submitDownloadModalData = async (data: any): Promise<any> => {
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: apiURL,
      url: 'pdfreport/generatepdf',
      method: 'POST',
      data,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching pdf modal data:', error);
    throw error;
  }
};

export const getRemediationPlanOptions = async (payload: any): Promise<any> => {
  const { reportId, custGroupId, demoGroupName, timeframe, wageType } = payload;
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: apiURL,
      url: `/costplanning/getremediationplans?reportId=${reportId}&custGroupId=${custGroupId}&demoGroupName=${demoGroupName}&timeframe=${timeframe}&wageType=${wageType}`,
      method: 'GET',
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching remediation plan options:', error);
    throw error;
  }
};


export const getCountrySpecificTemplate = async (countryCode: string): Promise<any> => {
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: apiURL,
      url: `/countryspecific/getCountrySpecificTemplate?countryCode=${countryCode}`,
      method: 'GET',
    });

    const { data } = response.data;
    useReportDeailStore.getState().updateCountryTemplateData(data);
    return response.data;
  } catch (error) {
    console.error('Error fetching country-specific template:', error);
    throw error;
  }
};

export const submitBulkEmployeeReport = async (data: any): Promise<any> => {
  try {
    const response = await kf1AuthenticatedHttpClient({
      baseURL: apiURL,
      url: '/rti/export/bulk/generate',
      method: 'POST',
      data,
    });
    return response.data;
  } catch (error) {
    console.error('Error generating bulk employee report:', error);
    throw error;
  }
};
